module.exports = __webpack_public_path__ + "static/YT-play-button-01334c68c780a5aaf85bfb196117aaa8.png";